<template>
  <v-container>
    <div style="margin-top: -5%;">
      <!-- <div style="background-color: rgb(230, 233, 242);" > -->
        <div>
        <v-row>
          <v-col cols="12" md="12">
            <!-- <p style="font-size: 1.25rem; color: rgb(0, 30, 67);"> Bienvenido</p> -->
            <p style="font-size: 18px; color: rgb(0, 30, 67)"><b>Corrupción y delitos ambientales</b></p>
            <p style="color: rgb(0, 30, 67);">
              Bienvenidos a este micrositio dedicado a abordar la corrupción y su relación con los problemas ambientales en Colombia. Aquí encontrarás herramientas 
              clave para comprender y combatir la corrupción vinculada a delitos ambientales, con especial énfasis en la deforestación.<br><br>
              
              En primer lugar, puedes consultar el Banco de Casos de Corrupción, que te permitirá conocer casos relacionados con la deforestación y sus causas 
              en esta primera fase. Esto facilitará la identificación de patrones y áreas de riesgo.<br><br>
              
              Además, tendrás acceso al curso virtual de acceso público titulado "Corrupción y Deforestación: Una Aproximación General al Fenómeno". 
              Este curso permitirá a la ciudadanía interesada profundizar en el vínculo entre la corrupción y los delitos ambientales.<br><br>

              También encontrarás una sección dedicada al control social ambiental y a los autodiagnósticos institucionales. Esta sección ofrece información y 
              recursos para ciudadanos y funcionarios públicos, con el objetivo de mejorar las acciones en la lucha contra la corrupción, promover la transparencia y asegurar la rendición de cuentas en las iniciativas ambientales.<br><br>
              
              Únete a la labor de la Secretaría de Transparencia en la promoción del control social y en la lucha contra la corrupción.
            </p>
          </v-col>
        </v-row>
      </div>
      <div>
        <v-row class="mb-3 justify-center">
          <v-col class="mb-12" md="3">
            <v-card class="mx-auto" height="200%" style="border-top: 5px solid #60A5D4; margin-top: 5px;">
              <!-- <router-link :to="{ name: 'casostotales' }" style="text-decoration: none;"> -->
              <router-link :to="{ name: 'casostotales' }" style="text-decoration: none;">
                <v-img class="d-flex align-end" height="100%" :src="require('../assets/banner2.jpg')">
                  <v-card-title class="fill-height align-end text-h6" style="color: white;">
                    Banco Casos
                  </v-card-title>
                </v-img>   
              </router-link>
            </v-card>
          </v-col>
          <v-col class="mb-12" md="3">
            <v-card class="mx-auto" height="200%" style="border-top: 5px solid #45C1E1; margin-top: 5px;">
              <!-- <router-link to="/controlsocial" style="text-decoration: none;"> -->
              <router-link :to="{ name: 'controlsocial' }" style="text-decoration: none;">
                <v-img class="align-end text-white" height="100%" :src="require('../assets/banner5.jpg')">
                  <v-card-title class="fill-height align-end text-h6" style="color: white;">
                    Control Social
                  </v-card-title>
                </v-img>   
              </router-link>         
            </v-card>
          </v-col>   
          <v-col class="mb-12" md="3">
            <v-card class="mx-auto" height="200%" style="border-top: 5px solid #C0497A; margin-top: 5px;">
              <router-link to="/curso" style="text-decoration: none;">
                <v-img class="align-end text-white" height="100%" :src="require('../assets/banner3.jpg')">
                  <v-card-title class="fill-height align-end text-h6" style="color: white;">
                    Curso
                  </v-card-title>
                </v-img>
              </router-link>
            </v-card>
          </v-col>      
          <v-col class="mb-12" md="3">
            <v-card class="mx-auto" height="200%" style="border-top: 5px solid #F9AC28; margin-top: 5px;">
              <router-link to="/" style="text-decoration: none;">
              <!-- <router-link to="/autodig" style="text-decoration: none;"> -->
                <v-img class="align-end text-white" height="100%" :src="require('../assets/banner4.jpg')">
                  <v-card-title class="fill-height align-end text-h6" style="color: white;">
                    Autodiagnóstico
                  </v-card-title>
                </v-img>            
              </router-link>
            </v-card>
          </v-col> 
        </v-row>
      </div><br><br>
    </div>
  </v-container>
</template>

<script>
  export default {
    name: 'HelloWorld',

    data: () => ({
      /* DATOS O VARIABLES*/
    }),
  }
</script>
<style>
    p {
      /* font-family: 'Heebo', sans-serif !important; */
        font-family: 'Roboto' !important;
        font-size: 14px;
        line-height: 1.6em;
        text-align: justify;
    }
    h1 {
      font-family: 'Heebo', sans-serif !important;
        font-size: 2.5rem;
    }
    h2 {
      font-family: 'Sofia Sans', sans-serif !important;
    }
</style>